/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/require-tagless-components */
import { classNames } from '@ember-decorators/component';
import { tracked } from '@glimmer/tracking';
// Extends From
import Component from '@ember/component';

import { isMobile } from '@linc-technologies/linced-common/utils/platform';

@classNames('post-with-sidecar', 'post-filter')
export default class GroupPostFilter extends Component {
  // Params
  startTime = 0;

  endTime = 0;
  selectedPages = [];
  remainingPages = [];
  selectedAuthors = [];
  sortedRemainingAuthors = [];
  proofreadPosts = true;
  notProofread = true;
  draftPosts = true;
  publishedPosts = true;
  unpublishedPosts = true;

  @tracked
  isMobile;

  togglePage() {}
  toggleAuthor() {}
  setTime() {}
  clear() {}
  setAutoFilter() {}
  toggleProofread() {}
  toggleNotProofread() {}
  toggleInDraft() {}
  toggleIsPublished() {}
  toggleCaregiversExcluded() {}

  init() {
    super.init(...arguments);
    this.isMobile = isMobile();
  }
}
